import { XMLValueParser as s } from "./values.js";
const i = {
  parse(t) {
    const e = new DOMParser().parseFromString(t, "text/xml");
    if (e.documentElement.tagName === "parsererror")
      throw new Error("Invalid XML syntax");
    return { root: n(e.documentElement) };
  }
};
function n(t) {
  const o = {};
  for (let r = 0; r < t.attributes.length; r++) {
    const a = t.attributes[r];
    o[a.name] = s.parse(a.value);
  }
  const e = [];
  for (let r = 0; r < t.children.length; r++)
    e.push(n(t.children[r]));
  return {
    tagName: t.tagName.toLowerCase(),
    attributes: o,
    children: e
  };
}
export {
  i as XMLParser
};
//# sourceMappingURL=parser.js.map
